export default "__VITE_ASSET__44f5e048__"